import { render, staticRenderFns } from "./FichePortrait.vue?vue&type=template&id=d58a1ec0&"
import script from "./FichePortrait.vue?vue&type=script&lang=js&"
export * from "./FichePortrait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports